import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
} from "@mui/material";
import Notification from "../Notification/Notification";
import Content from "../Content/Content";
import Carousel from "../Carousel/Carousel";
import SimpleThemeEditor from "../AppTheme/simple_theme_selection_screen";
import CustomerInteraction from "../CustomerInteraction/CustomerInteraction";
import IntroScreenManager from "../Intro-Screen/intro-screen";
import Muhurt from "../Muhurt/Muhurt";
import InterestingFacts from "../InterestingFacts/InterestingFacts";
import Reports from "../Reports/Reports";
import UiArrangementPage from "../UiArrangement/UiArrangementPage";
import Advertisement from "../Advertisement/Advertisement";
import AccessControl from "../../Comman/AccessControl";
import { controlAllFeatureOptions } from "../../../configs/constants";
import { canShowPermission } from "../Permissions/permissionObject";
import { useEffect } from "react";
import InfoButton from "../../Comman/InfoButton";


export default function AppManagementPage() {
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      setPermissions(JSON.parse(storedPermissions));
    }
  }, []);

  const canViewNotification = canShowPermission(permissions, "customNotification", "view");
  const canViewContent = canShowPermission(permissions, "content", "view");
  const canViewCarousel = canShowPermission(permissions, "carouselsettings", "view");
  const canViewAppTheme = canShowPermission(permissions, "appThemeSelector", "view");
  const canViewCustomerInteraction = canShowPermission(permissions, "customerInteraction", "view");
  const canViewIntroScreen = canShowPermission(permissions, "introScreen", "view");
  const canViewMuhurt = canShowPermission(permissions, "muhurt", "view");
  const canViewInterestingFacts = canShowPermission(permissions, "interestingFacts", "view");
  const canViewReports = canShowPermission(permissions, "reports", "view");
  const canViewUiArrangement = canShowPermission(permissions, "uiArrangement", "view");
  const canViewAdvertisement = canShowPermission(permissions, "advertisement", "view");

  const tabs = [
    canViewNotification && {
      label: t("tabs.notifications"),
      content: <Notification />
    },
    canViewContent && {
      label: t("tabs.contents"),
      content: <Content />
    },
    canViewCarousel && {
      label: t("tabs.carousals"),
      content: <Carousel />
    },
    canViewAppTheme && {
      label: t("tabs.appTheme"),
      content: <SimpleThemeEditor />
    },
    canViewCustomerInteraction && {
      label: t("tabs.customerInteraction"),
      content: <CustomerInteraction />
    },
    canViewIntroScreen && {
      label: t("tabs.introScreens"),
      content: <IntroScreenManager />
    },
    canViewMuhurt && {
      label: t("tabs.muhurat"),
      content: <Muhurt />
    },
    canViewInterestingFacts && {
      label: t("tabs.interestingFacts"),
      content: <InterestingFacts />
    },
    canViewReports && {
      label: t("tabs.reports"),
      content: <Reports />
    },
    canViewUiArrangement && {
      label: t("tabs.uiArrangement"),
      content: <UiArrangementPage />
    },
    canViewAdvertisement && {
      label: t("tabs.advertisement"),
      content: <Advertisement />
    }
  ]
  .filter(Boolean);

  return (    

    <Box sx={{ width: "100%", height: "100vh", overflow: "auto" }}>
      <Box sx={{ position: "relative" }}>
        <Box
          sx={{
          width: "100%",
          mt: { xs: 10, md: 10 },
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
        <Paper
          sx={{ p: { xs: 2, sm: 4 }, mb: 2, borderRadius: "16px" }}
          elevation={1}
        >
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            textColor="primary"
            indicatorColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              mb: 0,
              backgroundColor: "#f5f5f5",
              borderRadius: "8px",
              padding: "4px",
              "& .MuiTab-root": {
                fontWeight: 600,
                fontSize: "16px",
                textTransform: "none",
                minWidth: "auto",
                px: 2,
                borderRadius: "6px",
                margin: "0 4px",
                minHeight: "48px",
                "&.Mui-selected": {
                  backgroundColor: "#fff",
                  color: "#7A3FFF",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  borderBottom: "3px solid #7A3FFF",
                },
                "&:hover": {
                  backgroundColor: "rgba(122, 63, 255, 0.08)",
                },
              },
              "& .MuiTabs-indicator": {
                display: "none",
              },
            }}
          >
            {tabs.map((tab, index) => (
              <Tab key={index} label={tab.label} />
            ))}
          </Tabs>
          <Box sx={{ mt: 0 }}>
            {tabs[tabIndex]?.content}
          </Box>
        </Paper>
      </Box>
      <Box
    sx={{
      position: "fixed",
      bottom: 24,
      right: 24,
      zIndex: 1000,
    }}
  >
    <InfoButton pageName="APP_MANAGEMENT" />
  </Box>
    </Box>
  </Box>
  );
}

